import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiConfig} from '../../../configs/api.config';
import {IFeaturesConfiguration} from '../../../models/data.models';

@Injectable({
    providedIn: 'root'
})
export class AppConfigurationApiService {

    constructor(private httpClient: HttpClient) {}

    getConfiguration(): Observable<IFeaturesConfiguration> {
        return this.httpClient.get(ApiConfig.Settings.configuration) as Observable<IFeaturesConfiguration>;
    }
}
